export const setAuthToken = (token) => {
  localStorage.setItem('examapp_token', token);
};

export const getAuthToken = () => {
  return localStorage.getItem('examapp_token');
};

export const removeAuthToken = () => {
  localStorage.removeItem('examapp_token');
};

export const setUser = (user) => {
  localStorage.setItem('examapp_user', JSON.stringify(user));
};

export const getUser = () => {
  const user = localStorage.getItem('examapp_user');
  return user ? JSON.parse(user) : null;
};

export const removeUser = () => {
  localStorage.removeItem('examapp_user');
};

export const logout = () => {
  removeAuthToken();
  removeUser();
};